import { render, staticRenderFns } from "./Taxonomy.vue?vue&type=template&id=2d7b8692&"
import script from "./Taxonomy.vue?vue&type=script&lang=ts&"
export * from "./Taxonomy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports